const { useGetSample } = require('components/Hooks/useGetSample');

export function SensorValue({ value }) {
  const res = useGetSample(value);

  return (
    <div>{res?.value}</div>
  );
}